__turbopack_context__.v({
  "checkItem": "Contact-module__Bs3a0a__checkItem",
  "checkItemIcon": "Contact-module__Bs3a0a__checkItemIcon",
  "checkItemText": "Contact-module__Bs3a0a__checkItemText",
  "contactBreadcrumbBar": "Contact-module__Bs3a0a__contactBreadcrumbBar",
  "contactContainer": "Contact-module__Bs3a0a__contactContainer",
  "contactHero": "Contact-module__Bs3a0a__contactHero",
  "contactHeroInner": "Contact-module__Bs3a0a__contactHeroInner",
  "contactHeroSubtitle": "Contact-module__Bs3a0a__contactHeroSubtitle",
  "contactHeroTitle": "Contact-module__Bs3a0a__contactHeroTitle",
  "contactPage": "Contact-module__Bs3a0a__contactPage",
  "contactSpin": "Contact-module__Bs3a0a__contactSpin",
  "formAlert": "Contact-module__Bs3a0a__formAlert",
  "formAlertError": "Contact-module__Bs3a0a__formAlertError",
  "formAlertSuccess": "Contact-module__Bs3a0a__formAlertSuccess",
  "formGrid": "Contact-module__Bs3a0a__formGrid",
  "formGridHalf": "Contact-module__Bs3a0a__formGridHalf",
  "formHeader": "Contact-module__Bs3a0a__formHeader",
  "formHeaderIcon": "Contact-module__Bs3a0a__formHeaderIcon",
  "formInput": "Contact-module__Bs3a0a__formInput",
  "formSpinner": "Contact-module__Bs3a0a__formSpinner",
  "formSubmitButton": "Contact-module__Bs3a0a__formSubmitButton",
  "formTextarea": "Contact-module__Bs3a0a__formTextarea",
  "formTitle": "Contact-module__Bs3a0a__formTitle",
  "formWrapper": "Contact-module__Bs3a0a__formWrapper",
  "gridThree": "Contact-module__Bs3a0a__gridThree",
  "gridTwo": "Contact-module__Bs3a0a__gridTwo",
  "gridTwoLarge": "Contact-module__Bs3a0a__gridTwoLarge",
  "infoCard": "Contact-module__Bs3a0a__infoCard",
  "infoCardHighlight": "Contact-module__Bs3a0a__infoCardHighlight",
  "infoCardIconWrap": "Contact-module__Bs3a0a__infoCardIconWrap",
  "infoCardPrimaryNote": "Contact-module__Bs3a0a__infoCardPrimaryNote",
  "infoCardSmallText": "Contact-module__Bs3a0a__infoCardSmallText",
  "infoCardSmallTextSpaced": "Contact-module__Bs3a0a__infoCardSmallTextSpaced",
  "infoCardText": "Contact-module__Bs3a0a__infoCardText",
  "infoCardTextBold": "Contact-module__Bs3a0a__infoCardTextBold",
  "infoCardTitle": "Contact-module__Bs3a0a__infoCardTitle",
  "linkCard": "Contact-module__Bs3a0a__linkCard",
  "linkCardDescription": "Contact-module__Bs3a0a__linkCardDescription",
  "linkCardIconWrap": "Contact-module__Bs3a0a__linkCardIconWrap",
  "linkCardInner": "Contact-module__Bs3a0a__linkCardInner",
  "linkCardTitle": "Contact-module__Bs3a0a__linkCardTitle",
  "paper": "Contact-module__Bs3a0a__paper",
  "paperCheckList": "Contact-module__Bs3a0a__paperCheckList",
  "section": "Contact-module__Bs3a0a__section",
  "sectionDescription": "Contact-module__Bs3a0a__sectionDescription",
  "sectionNote": "Contact-module__Bs3a0a__sectionNote",
  "sectionTitle": "Contact-module__Bs3a0a__sectionTitle",
  "warningAlertBox": "Contact-module__Bs3a0a__warningAlertBox",
  "warningAlertIcon": "Contact-module__Bs3a0a__warningAlertIcon",
  "warningAlertText": "Contact-module__Bs3a0a__warningAlertText",
  "warningItem": "Contact-module__Bs3a0a__warningItem",
  "warningItemDot": "Contact-module__Bs3a0a__warningItemDot",
  "warningItemText": "Contact-module__Bs3a0a__warningItemText",
  "warningText": "Contact-module__Bs3a0a__warningText",
});
